import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { saveAboutUs, updateContent } from "../../store/feature/aboutusSlice";

const AddAboutUs: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { content, loading, message, error } = useSelector((state: RootState) => state.aboutus);

  const [inputContent, setInputContent] = useState(content);

  const handleSave = () => {
    if (!inputContent.trim()) {
      alert("Hakkımızda içeriği boş olamaz!");
      return;
    }

    dispatch(saveAboutUs({ token: "", content: inputContent }));
    dispatch(updateContent(inputContent)); // Update the local state in the slice
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-gray-100 shadow-lg rounded-lg">
      <h1 className="text-2xl font-bold text-center mb-6">Hakkımızda İçeriği</h1>

      {/* Input Area */}
      <textarea
        value={inputContent}
        onChange={(e) => setInputContent(e.target.value)}
        placeholder="Hakkımızda içeriğini buraya yazın..."
        className="w-full h-40 p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none resize-none"
      ></textarea>

      <button
        onClick={handleSave}
        className={`mt-4 w-full py-2 px-4 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 transition ${
          loading ? "opacity-50 cursor-not-allowed" : ""
        }`}
        disabled={loading}
      >
        {loading ? "Kaydediliyor..." : "Kaydet"}
      </button>

      {message && <p className="text-green-600 mt-2">{message}</p>}
      {error && <p className="text-red-600 mt-2">{error}</p>}

      {/* Preview Area */}
      <div className="mt-8 p-4 bg-white border border-gray-300 rounded-lg">
        <h2 className="text-xl font-semibold mb-4">Önizleme</h2>
        <div className="whitespace-pre-line leading-relaxed text-gray-800">
          {inputContent || "Hakkımızda içeriği buraya girildiğinde önizleme burada görünecek."}
        </div>
      </div>
    </div>
  );
};

export default AddAboutUs;
